module.exports = "<h2>Page not found!</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-not-found/page-not-found.component.html
// module id = ./src/app/components/pages/page-not-found/page-not-found.component.html
// module chunks = main